import Ants from "@assets/icons/ants.svg?react";
import Share from "@src/app/components/SocialMedia";
import clsx from "clsx";
import type { ReactElement } from "react";

import Link from "../Link";

interface ShareAntsToggleProps {
  isHeaderSticky: boolean;
}

export default function ShareAntsToggle({
  isHeaderSticky,
}: ShareAntsToggleProps): ReactElement {
  return (
    <div className="relative hidden items-center lg:flex">
      {/* Share组件 */}
      <div
        className={clsx(
          "transition-all duration-500 ease-in-out",
          isHeaderSticky
            ? "!hidden translate-x-[-20px]"
            : "!block translate-x-0",
        )}
      >
        <Share />
      </div>

      {/* Ants组件 */}
      <Link
        to={"/"}
        className={clsx(
          "transition-all duration-500 ease-in-out",
          isHeaderSticky
            ? "!block translate-x-0"
            : "!hidden translate-x-[20px]",
        )}
      >
        <Ants className="size-[32px]" />
      </Link>
    </div>
  );
}
